function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "ListIcon");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "ListIcon",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "List-Bullets",
  transform: "translate(0.000000, 0.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "list-bullets",
  transform: "translate(3.333333, 13.333333)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.66666667,13.3333333 C2.98476833,13.3333333 0,10.348565 0,6.66666667 C0,2.98476833 2.98476833,0 6.66666667,0 C10.348565,0 13.3333333,2.98476833 13.3333333,6.66666667 C13.3333333,8.4347766 12.6309544,10.1304694 11.3807119,11.3807119 C10.1304694,12.6309544 8.4347766,13.3333333 6.66666667,13.3333333 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70,10 L23.3333333,10 C21.4923842,10 20,8.50761583 20,6.66666667 C20,4.8257175 21.4923842,3.33333333 23.3333333,3.33333333 L70,3.33333333 C71.8409492,3.33333333 73.3333333,4.8257175 73.3333333,6.66666667 C73.3333333,8.50761583 71.8409492,10 70,10 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.66666667,33.3333333 C2.98476833,33.3333333 0,30.348565 0,26.6666667 C0,22.9847683 2.98476833,20 6.66666667,20 C10.348565,20 13.3333333,22.9847683 13.3333333,26.6666667 C13.3333333,30.348565 10.348565,33.3333333 6.66666667,33.3333333 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70,30 L23.3333333,30 C21.4923842,30 20,28.5076158 20,26.6666667 C20,24.8257175 21.4923842,23.3333333 23.3333333,23.3333333 L70,23.3333333 C71.8409492,23.3333333 73.3333333,24.8257175 73.3333333,26.6666667 C73.3333333,28.5076158 71.8409492,30 70,30 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.66666667,53.3333333 C2.98476833,53.3333333 0,50.348565 0,46.6666667 C0,42.9847683 2.98476833,40 6.66666667,40 C10.348565,40 13.3333333,42.9847683 13.3333333,46.6666667 C13.3333333,50.348565 10.348565,53.3333333 6.66666667,53.3333333 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70,50 L23.3333333,50 C21.4923842,50 20,48.5076158 20,46.6666667 C20,44.8257175 21.4923842,43.3333333 23.3333333,43.3333333 L70,43.3333333 C71.8409492,43.3333333 73.3333333,44.8257175 73.3333333,46.6666667 C73.3333333,48.5076158 71.8409492,50 70,50 Z",
  id: "Path"
}))));

var SvgTopicsIcon = function SvgTopicsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTopicsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/TopicsIcon.224f7b23.svg";
export { ForwardRef as ReactComponent };